import { createRoutine } from 'redux-saga-routines';

export const fetchAllScenarios = createRoutine('FETCH_ALL_SCENARIOS');
export const fetchScenarioById = createRoutine('FETCH_SCENARIO_BY_ID');
export const createScenario = createRoutine('CREATE_SCENARIO');
export const archiveScenario = createRoutine('ARCHIVE_SCENARIO');
export const deleteScenario = createRoutine('DELETE_SCENARIO');
export const renameScenario = createRoutine('RENAME_SCENARIO');
export const activateScenario = createRoutine('ACTIVATE_SCENARIO');
export const deactivateScenario = createRoutine('DEACTIVATE_SCENARIO');
export const updateScenario = createRoutine('UPDATE_SCENARIO');
export const openNodeExecutionAttendedListDrawer = createRoutine(
  'OPEN_SCENARIO_FAIL_SKIP_DRAWER'
);
export const closeNodeExecutionAttendedListDrawer = createRoutine(
  'CLOSE_SCENARIO_FAIL_SKIP_DRAWER'
);
export const openNodeExecutionRejectedListDrawer = createRoutine(
  'OPEN_SCENARIO_REJECTED_DRAWER'
);
export const closeNodeExecutionRejectedListDrawer = createRoutine(
  'CLOSE_SCENARIO_REJECTED_DRAWER'
);
export const openNodeExecutionCompletedListDrawer = createRoutine(
  'OPEN_SCENARIO_COMPETED_DRAWER'
);
export const closeNodeExecutionCompletedListDrawer = createRoutine(
  'CLOSE_SCENARIO_COMPLETED_DRAWER'
);
export const fetchNodeExecutionSummary = createRoutine(
  'FETCH_NODE_EXECUTION_SUMMARY'
);
export const fetchNodeExecutionAttendedFailList = createRoutine(
  'FETCH_NODE_EXECUTION_ATTENDED_FAIL_LIST'
);
export const fetchNodeExecutionAttendedSkipList = createRoutine(
  'FETCH_NODE_EXECUTION_ATTENDED_SKIP_LIST'
);
export const fetchNodeExecutionRejectedList = createRoutine(
  'FETCH_NODE_EXECUTION_REJECTED_LIST'
);
export const dismissNodeExecutionUnattendedList = createRoutine(
  'DISMISS_NODE_EXECUTION_UNATTENDED'
);
export const fetchNodeExecutionCompletedList = createRoutine(
  'FETCH_NODE_EXECUTION_COMPLETED_LIST'
);
export const duplicateScenario = createRoutine('DUPLICATE_SCENARIO');
export const retryFailedNodeExecutions = createRoutine(
  'RETRY_NODE_EXECUTION_UNATTENDED'
);

export const resetSelectedScenario = createRoutine(
  'RESET_SELECTECTED_SCENARIO'
);
export const fetchScenarioEmailServiceType = createRoutine(
  'FETCH_SCENARIO_EMAIL_SERVICE_TYPE'
);
